import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { SseService } from 'src/app/services/SseService';
import { BrokerService } from 'src/app/services/broker.services';
import { RealTimeService } from 'src/app/services/realtime.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { ibrkServices } from 'src/app/services/ibrk.service';
import { OAuthService } from 'src/app/services/oauth.service';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { ToastrService } from 'ngx-toastr';
import { motivoRechazoMetaApi } from 'src/app/services/meta-api-error-messages';
import { MetaApiStreamingService } from 'src/app/services/metaapi-streaming.service';
@Component({
  selector: 'app-cerrar-posicion',
  templateUrl: './cerrar-posicion.component.html',
  styleUrl: './cerrar-posicion.component.scss'
})
export class CerrarPosicionComponent implements OnInit, OnDestroy {

  public posicion: any;
  public ListaPosicion: any;
  public optimaWallet: any;
  public dataSource: any;
  public subPosicionesBroker: Subscription;
  public selectedDato: any;
  public cotizacion: any;
  public isActual: number = 0;
  public retorno: any;
  public theme: any;
  public tipoBroker: string = 'IBKR';
  public metaApiAccountId: string = '';

  public ordersData = {
    orders: [
      {
        orderType: 'MKT',
        ticker: 'AAPL',
        side: 'SELL',
        quantity: 0,
        remainingquantity: 0,
        acctId: 'DU149954',
        cOID: 'nctminvst1714425916446-AAPL0:A',
        secType: '265598:STK',
        filledquantity: 0,
        parentId: 'nctminvst1714425916446-AAPL0:A',
        tif: 'GTC',
        outsideRTH: false,
        referrer: 'modelosdeinversion',
        useAdaptive: false,
        conid: 0
      }
    ]
  };
  public orderType: string[] = [
    'MKT',
    'LMT',
    'STP'
  ];

  constructor( public toastr: ToastrService,
    public dialogRef: MatDialogRef<CerrarPosicionComponent>,
    private _cookieService: CookieService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sseservice: SseService,
    private datePipe: DatePipe,
    private _httpclient: HttpClient,
    private _brokerServcice: BrokerService,
    public dialog: MatDialog,
    private _realtimeservice: RealTimeService,
    private _ibrkService: ibrkServices, private oauthService: OAuthService,
    private brokerAdapterFactory: BrokerAdapterFactory,
    private metaApiStreaming: MetaApiStreamingService
  ) {

  }
  ngOnDestroy(): void {
    this.subPosicionesBroker.unsubscribe();
  }
  ngOnInit(): void {
    this.ListaPosicion = this.data.listaPosiciones;
    this.posicion = this.data.posicion;
    this.optimaWallet = this.data.optimaWallet;
    this.tipoBroker = this.data.tipoBroker ?? 'IBKR';
    this.metaApiAccountId = this.data.metaApiAccountId ?? '';
    this.valorTiempoReal();
    this.theme = localStorage.getItem('theme') || 'light-theme';
  }
  seleccionarDato() {
    console.log(this.selectedDato);
    this.subPosicionesBroker.unsubscribe();
    this.posicion = this.selectedDato;
    //this.valorHistorico();
    this.valorTiempoReal();
  }

  valorTiempoReal() {
    console.log("posicion", this.posicion);
    // MetaTrader: precio del propio broker. FMP no conoce sus símbolos (XAGUSD.sa, #AAPL) y se
    // le preguntaba cada segundo sin obtener nada.
    if (this.tipoBroker === 'METAAPI') {
      this.metaApiStreaming.useAccount(this.metaApiAccountId || this.optimaWallet?.nombre);
      this.subPosicionesBroker = this.metaApiStreaming.prices$([this.posicion.contractDesc], 1000).subscribe(p => {
        const bid = Number(p?.bid ?? p?.ask);
        const ask = Number(p?.ask ?? p?.bid);
        if (bid) this.aplicarPrecio([{ symbol: p.symbol, bidPrice: bid, askPrice: ask, lastSalePrice: bid }]);
      });
      return;
    }
    // encodeURIComponent: un '#' sin codificar cortaba la URL (fragmento)
    let url = 'v3/stock/full/real-time-price/' + encodeURIComponent(this.posicion.contractDesc);
    console.log("url del tiempo real", url)
    this.subPosicionesBroker = this._realtimeservice.fetchDataEverySecond(url).subscribe({
      next: (data: any) => {
        console.log("data RT", data);
        data[0].lastSalePrice = parseFloat((data[0].lastSalePrice).toFixed(2));
        this.aplicarPrecio(data);
      }
    });
  }

  private aplicarPrecio(data: any[]): void {
    this.dataSource = data;
    const lastSalePrice = data[0].lastSalePrice;
    if (this.isActual == 0) {
      this.isActual = lastSalePrice
      this.retorno = parseFloat((this.posicion.coste - (this.posicion.position * this.isActual)).toFixed(2));
    } else if (this.isActual !== lastSalePrice) {
      this.retorno = parseFloat((this.posicion.coste - (this.posicion.position * this.isActual)).toFixed(2));
    }
  }

  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  enviarPosicion() {
    this.brokerAdapterFactory.puedeOperar(this.tipoBroker).subscribe(ok => { if (ok) this.enviarPosicionConfirmado(); });
  }

  private enviarPosicionConfirmado() {
    // --- MetaAPI path: no whatif/reply, direct market order ---
    if (this.tipoBroker === 'METAAPI') {
      if (this.posicion.position === 0) {
        this.dialog.open(ConfirmDialogComponent, { width: '380px', height: '250px', panelClass: this.theme, data: { msj: 'Numero de Acciones debe ser Mayor a 0' } });
        return;
      }
      const trade = {
        actionType: 'POSITION_CLOSE_ID',
        positionId: String(this.posicion.conid)
      };
      const accountId = this.metaApiAccountId || this.optimaWallet.nombre;
      const wallet = { ...this.optimaWallet, tipoBroker: 'METAAPI', metaApiAccountId: accountId };
      this.brokerAdapterFactory.getAdapter(wallet).placeOrder(accountId, trade).subscribe({
        next: (resp: any) => {
          console.log('MetaAPI close position response', resp);
          const rechazo = motivoRechazoMetaApi(resp);
          if (rechazo) {
            this.toastr.error('Error al cerrar posición MetaAPI: ' + rechazo, 'Error');
            return;
          }
          this.toastr.success('Posición cerrada correctamente', 'Éxito');
          this.dialogRef.close();
        },
        error: (err: any) => {
          this.toastr.error('Error al cerrar posición MetaAPI: ' + (err?.message ?? JSON.stringify(err)), 'Error');
          this.dialogRef.close();
        }
      });
      return;
    }

    let URLNEW = '/iserver/account/' + this.optimaWallet.nombre + '/orders ';
    let fechaMilisegundos = new Date().getTime();
    let side: string='';
    if (this.posicion.position > 0) {
      side = 'SELL';
    } else if (this.posicion.position < 0) {
      side = 'BUY';
    }
    if (this.posicion.position !== 0) {
      console.log("DATOS DE LA COMPAÑIA: ", this.posicion);
      console.log("DATOS DE CARTERA: ", this.optimaWallet);
      this.ordersData.orders[0].ticker = this.posicion.contractDesc;
      this.ordersData.orders[0].quantity = Math.abs(this.posicion.position);//side
      this.ordersData.orders[0].side = side;
      this.ordersData.orders[0].acctId = this.optimaWallet.nombre;
      this.ordersData.orders[0].cOID = 'nctminvst' + fechaMilisegundos + '-' + this.posicion.contractDesc + ':A';
      this.ordersData.orders[0].secType = this.posicion.conid + ':' + this.posicion.assetClass;
      this.ordersData.orders[0].parentId = 'nctminvst' + fechaMilisegundos + '-' + this.posicion.contractDesc + ':A';
      this.ordersData.orders[0].conid = Number(this.posicion.conid);
      console.log("ESTO ENVIAMS A BROKER: ", this.ordersData);
      let licencia = this._cookieService.get('auth_token');
      let urlwhatif = '/iserver/account/' + this.optimaWallet.nombre + '/orders/whatif';
    this.oauthService.apiPostIbrk(urlwhatif, this.ordersData).subscribe({
      next: (data: any) => {
        if (Number(data.position.after) === 0) {      
         //  this._sseservice.apiPostNew('broker/orderNuevo', this.ordersData.orders, licencia).subscribe({
          //  next: (response: any) => {
          this.oauthService.apiPostIbrk(URLNEW, this.ordersData).subscribe({
            next: (data: any)=>{
              console.log("ESTO RESPONDE BROKER",data);
              if(data[0].message){
                const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                  width: '380px',
                  height: '250px',
                  panelClass: this.theme,
                  data: {
                    msj: data[0].message
                  }
                });
                dialogRef.afterClosed().subscribe(result => {
                  console.log('El diálogo se cerró');
                  if (result) {
                    this.confirmarOp(data[0].id);
                    this.dialogRef.close();
                  } else {
                    // Lógica a ejecutar si se cancela la acción
                    console.log('La acción fue cancelada');
                    this.dialogRef.close();
                  }
                });
              }else if(data[0].order_status != null){
              
                this.toastr.success('Se registro Orden: ' + data[0].order_id + ' ' + data[0].order_status, 'Orden', { timeOut: 3000, positionClass: 'toast-top-center' });
                this.dialogRef.close();
            }
            }
          });
       // },
        //    error: (error:any) => {
         //   }
        //  });
        }else{
          this.toastr.error('No se puede cerrar la posición, la cantidad de acciones la cantidad de acciones es incorrecta ' + this.posicion.contractDesc, 'Error');
        }
      }
    }); 
      
    }else{
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'Numero de Acciones debe ser Mayor a 0'
        }
      });
    }
    this.dialogRef.close();
  }

  confirmarOp(idmsg: any) {
    let url = '/iserver/reply/' + idmsg;
    let dataJson = { confirmed: true }
    this.oauthService.apiPostIbrk(url, dataJson).subscribe({
      next: (data: any)=>{
        console.log("DATOS DESDE REPLY: ", data);
        if(data[0].id)
          this.confirmarOp(data[0].id);
        this.dialogRef.close();
      }
    });
  }
}
